package game.entity

import game.*
import kotlin.random.Random

class WanderComponent(val speed: Int, val avoidPlayer: Boolean, val targetTileType: TileType = TileType.Floor) {
    var colVel = 0
    var rowVel = 0
    private var distance = 0
    private var coolDown = 0

    fun tick(game: Game, room: Room, entity: Entity) {
        if (coolDown > 0) {
            coolDown--
        } else {
            if (distance > 0) {
                if (canMove(game, room, entity)) {
                    entity.col += colVel
                    entity.row += rowVel
                    distance--

                    coolDown = if (distance == 1) speed * 4 else speed
                } else {
                    distance = 0
                    coolDown = 0
                }
            } else {
                chooseNewDirection()
            }
        }
    }

    private fun chooseNewDirection() {
        when (Random.nextInt(4)) {
            0 -> {
                colVel = 1
                rowVel = 0
            }
            1 -> {
                colVel = -1
                rowVel = 0
            }
            2 -> {
                colVel = 0
                rowVel = 1
            }
            3 -> {
                colVel = 0
                rowVel = -1
            }
        }

        distance = Random.nextInt(1, 6)
    }

    private fun canMove(game: Game, room: Room, entity: Entity): Boolean {
        val destCol = entity.col + colVel
        val destRow = entity.row + rowVel

        if (room[destCol, destRow].type != targetTileType) {
            return false
        }

        if (destCol < 3 || destCol > ROOM_WIDTH - 4
            || destRow < 3 || destRow > ROOM_HEIGHT - 4
        ) {
            return false
        }

        if (room.getEntityAt(destCol, destRow) != null) {
            return false
        }

        if (avoidPlayer && game.player.col == destCol && game.player.row == destRow) {
            return false
        }

        return true
    }
}